var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect } from 'react';
import { LoadingSpinner, LockIcon, Text } from '@paypalcorp/pp-react';
import { getProp } from '../common/utils';
import { initializeAsync, initializeSync } from '../common/fn';
import { PUBLIC_CREDENTIAL, PASSWORD } from '../common/views';
export default ({ authEventHandler, authProviderContext = { fnData: {}, cookiedUser: {} }, localizedContent, logger, sessionID, performWebLLSLogin, publicCredential, setCsrf, setView, setIsWebLLSUser, }) => {
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const startTime = Date.now();
            initializeAsync(authProviderContext.fnData);
            yield initializeSync(authProviderContext.fnData);
            logger.track('weblls_rendered');
            authEventHandler({ event: 'beginLogin', data: { loginMethod: 'weblls' } });
            logger.track('weblls_started');
            const response = yield performWebLLSLogin();
            // XO Lite apps do not have the ngRL JS SDK loaded,
            // hence a captcha response can go unhandled
            // the following is a poor way to handle it so that XO can fallback
            const extensions = getProp(response, 'extensions', null);
            if (!extensions) {
                authEventHandler({
                    event: response === 'invalid_ctxId' ? 'invalidCtxId' : 'unknownResponse',
                    data: {
                        response,
                    },
                });
            }
            const accessToken = getProp(response, 'data.webLLS.performWebLLSLogin.accessToken');
            if (accessToken) {
                logger.track('weblls_succeeded');
                authEventHandler({ event: 'loggedIn', data: { accessToken, loginMethod: 'weblls' } });
            }
            else {
                logger.track('weblls_failed');
                setCsrf(response._csrf);
                setIsWebLLSUser(false);
                setView(publicCredential ? PASSWORD : PUBLIC_CREDENTIAL);
                authEventHandler({
                    event: 'loginFailed',
                    data: { loginMethod: 'weblls' },
                });
            }
            logger.track(`cpl_weblls|${JSON.stringify({
                start: startTime,
                tt: Date.now() - startTime,
                login_experience: 'Weblls login',
            })}`);
            logger.flush({ csrf: response._csrf, sessionID });
        }))();
    }, []);
    return (React.createElement("div", { style: { margin: '0 auto', textAlign: 'center', position: 'relative' } },
        React.createElement(LoadingSpinner, { size: "xl", style: { margin: '40px auto' }, screenReaderText: localizedContent('loading') }),
        React.createElement(Text, { size: "xl2", className: "heading" }, localizedContent('webLlsHeading', { firstName: authProviderContext.cookiedUser.firstName })),
        React.createElement(Text, { size: "lg" }, localizedContent('webLlsBody')),
        React.createElement(Text, null, localizedContent('manageSetting'))));
};
